import { billedBySchema, billingStatusSchema, dueDateRuleSchema, monthSchema, unitAssessmentSchema, } from '@teo/types';
import { z } from 'zod';
import { displayId } from './common.js';
export const getBillingSetupSchema = z.object({
    ownershipId: displayId,
});
export const billingPropertySummarySchema = z.object({
    propertyId: z.number(),
    propertyDisplayId: z.string(),
    address: z.string(),
    status: billingStatusSchema,
    goLiveMonth: monthSchema.nullable(),
    dueDateRule: dueDateRuleSchema.nullable(),
    customerMemo: z.string().nullable(),
    issueDaysAhead: z.number().int().min(0).max(30).nullable(),
});
export const getBillingSetupOutputSchema = z.object({
    billedBy: billedBySchema.nullable(),
    properties: z.array(billingPropertySummarySchema),
});
export const updateBillingDraftSchema = z.object({
    ownershipId: displayId,
    propertyId: z.number(),
    goLiveMonth: monthSchema,
    dueDateRule: dueDateRuleSchema,
    customerMemo: z.string().max(1000).optional(),
    issueDaysAhead: z.number().int().min(0).max(30).optional(),
});
export const billingUnitRowSchema = z.object({
    unitDisplayId: z.string(),
    ownerName: z.string(),
    assessment: unitAssessmentSchema,
});
export const getBillingTableSchema = z.object({
    ownershipId: displayId,
    propertyRowId: z
        .number()
        .describe("The property's numeric row id, as getBillingSetup returns it. Do not send a PROP display id."),
});
export const getBillingTableOutputSchema = z.object({
    units: z.array(billingUnitRowSchema),
});
export const confirmBillingAmountsSchema = z.object({
    ownershipId: displayId,
    propertyId: z.number(),
});
export const confirmBillingAmountsOutputSchema = z.object({
    schedulesCreated: z.number(),
    schedulesUpdated: z.number(),
    schedulesSkipped: z.number(),
});
export const activateBillingSchema = z.object({
    ownershipId: displayId,
    propertyId: z.number(),
});
const activateBillingRowBase = { ownerName: z.string(), unitDisplayId: z.string() };
export const activateBillingResultSchema = z.discriminatedUnion('success', [
    z.object({
        ...activateBillingRowBase,
        success: z.literal(true),
        skipped: z.enum(['already_has_template', 'nothing_to_bill']).optional(),
        error: z.never().optional(),
    }),
    z.object({
        ...activateBillingRowBase,
        success: z.literal(false),
        error: z.string(),
        skipped: z.never().optional(),
    }),
]);
export const activateBillingOutputSchema = z.object({
    results: z.array(activateBillingResultSchema),
});
//# sourceMappingURL=billing.js.map